/**
 * Ensures a value is an array, if it isn't it wraps it in an array
 * @param {any} v - the value to ensure
 * @returns {[]} an array
 */
export function ensureArray(v) {
    if (Array.isArray(v)) return v
    return [v].filter((v) => v !== undefined)
}
